import React, { Component } from 'react';
import { Modal, Input, Button } from 'antd';
import { SearchTransactionWrapper } from './style';
import { searchTransactions } from '../../common/fetch';

class CheckTransaction extends Component {
	state = {
		id: '',
		address: '',
		result: null,
		error: null
	};

	handleInputChange = (e) => {
		const { name, value } = e.target;
		this.setState({ [name]: value });
	};

	handleClick = async () => {
		const { checkData } = this.props;
		const { id, address } = this.state;
		const query = `?currency=${checkData.data.currency}&&transaction_id=${id}&&address=${address}&&is_testnet=${checkData.data.is_testnet}`;
		try {
			const res = await searchTransactions(query);
			this.setState({ result: res.data });
		} catch (error) {
			this.setState({ error: error.data.message });
		}
	};

	tryAgain = () => {
		this.setState({ error: null });
	};
	renderBody = () => {
		const { result, error } = this.state;
		if (result) {
			return (
				<SearchTransactionWrapper>
					<h2 className="center">Search For Transaction</h2>
					<p>Transaction with the details below is found:</p>
					<p className="status">
						<b>Transaction ID : </b>
						{result.txid}
					</p>
					<p className="status">
						<b>Amount : </b>
						{result.amount}
					</p>
					<p className="status">
						<b>Status : </b>
						{result.is_confirmed
							? 'Confirmed'
							: result.is_suspicious
							? 'Failed'
							: 'Pending'}
					</p>
					<div className="btn-area">
						<Button
							block
							type="primary"
							onClick={() => {
								this.props.handleOk(result);
							}}
						>
							Okay
						</Button>
					</div>
				</SearchTransactionWrapper>
			);
		}
		if (error) {
			return (
				<SearchTransactionWrapper>
					<h2 className="center">Transaction Not Found</h2>
					<div className="btn-area">
						<Button block onClick={this.props.handleCancel}>
							Close
						</Button>
						<Button block type="primary" onClick={this.tryAgain}>
							Search Again
						</Button>
					</div>
				</SearchTransactionWrapper>
			);
		}
		return (
			<SearchTransactionWrapper>
				<h2>Search For Transaction</h2>
				<div>
					<p>Transaction Id</p>
					<Input
						name="id"
						value={this.state['id']}
						onChange={this.handleInputChange}
					/>
				</div>
				<div>
					<p>Address</p>
					<Input
						name="address"
						value={this.state['address']}
						onChange={this.handleInputChange}
					/>
				</div>
				<div className="btn-area">
					<Button block onClick={this.props.handleCancel}>
						Back
					</Button>
					<Button type="primary" block onClick={this.handleClick}>
						Search
					</Button>
				</div>
			</SearchTransactionWrapper>
		);
	};
	render() {
		const { visible, handleCancel, handleOk } = this.props;

		return (
			<Modal
				visible={visible}
				title={null}
				onOk={() => {
					handleOk(this.state);
				}}
				onCancel={handleCancel}
				footer={null}
			>
				{this.renderBody()}
			</Modal>
		);
	}
}

export default CheckTransaction;
